import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api";
import { parseJWT } from "../utils/jwtUtils";

const UpdateProfile = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: "",
    phone: "",
    password: "",
  });
  const token = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;
  const userInfo = parseJWT(token?.token);

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  // 🧠 Load user info once
  useEffect(() => {
    if (userInfo) {
      setFormData({
        username: userInfo.username || "",
        phone: userInfo.phone || "",
        password: "",
      });
    }
  }, []);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // 🚀 Submit update
  const handleUpdate = async (e) => {
    e.preventDefault();

    if (!formData.username || !formData.phone || !formData.password) {
      setMessage("Please fill all required fields.");
      return;
    }

    if (!userInfo?.id) {
      setMessage("User info not found. Please log in again.");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const response = await api.put(`/users/${userInfo.id}`, {
        username: formData.username,
        phone: formData.phone,
        password: formData.password,
      });

      if (response.data?.success) {
        setMessage("✅ Profile updated successfully!");
        const stored = JSON.parse(localStorage.getItem("userInfo")) || {};
        localStorage.setItem(
          "userInfo",
          JSON.stringify({
            ...stored,
            username: formData.username,
            phone: formData.phone,
          }),
        );
        setTimeout(() => navigate("/"), 1500);
      } else {
        setMessage(response.data?.message || "❌ Failed to update profile.");
      }
    } catch (err) {
      console.error("Update error:", err);
      setMessage(err.response?.data?.message || "❌ Failed to update profile.");
    } finally {
      setLoading(false);
    }
  };
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  return (
    <div className="min-h-screen bg-[#082f52] text-white flex justify-center items-center px-4 py-6">
      <div className="w-full max-w-md bg-[#12385d] rounded-xl shadow-lg p-6 sm:p-8">
        <h1 className="text-2xl sm:text-3xl font-semibold mb-3 text-center text-white font-serif">
          Update Profile Info
        </h1>

        <form onSubmit={handleUpdate} className="space-y-4 text-left">
          {/* Username */}
          <div>
            <label className="text-gray-200 text-sm font-serif">Username</label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder="Enter Username"
              className="mt-1 w-full bg-[#0e2b48] border border-[#2c4e74] text-white rounded-md px-3 py-2 sm:py-3 focus:ring-2 focus:ring-blue-400 outline-none text-sm sm:text-base"
            />
          </div>

          {/* Phone */}
          <div>
            <label className="text-gray-200 text-sm font-serif">
              Phone Number
            </label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              readOnly
              placeholder="Enter Phone Number"
              className="mt-1 w-full bg-[#0e2b48] border border-[#2c4e74] text-white rounded-md px-3 py-2 sm:py-3 focus:ring-2 focus:ring-blue-400 outline-none text-sm sm:text-base"
            />
          </div>

          {/* Password */}
          <div>
            <label className="text-gray-200 text-sm font-serif">Password</label>
            <div className="relative flex items-center">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter New Password"
                className="mt-1 w-full bg-[#0e2b48] border border-[#2c4e74] text-white rounded-md px-3 py-2 sm:py-3 focus:ring-2 focus:ring-blue-400 outline-none text-sm sm:text-base"
              />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill={showPassword ? "#000000" : " #3E3ECE"} // Dynamic color based on state
                className="w-[18px] h-[18px] absolute right-2 cursor-pointer"
                onClick={togglePasswordVisibility}
                viewBox="0 0 128 128"
              >
                <path d="M64 16c-32 0-58.4 20.8-64 48 5.6 27.2 32 48 64 48s58.4-20.8 64-48c-5.6-27.2-32-48-64-48zm0 80c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm0-48c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16z" />
              </svg>
            </div>
          </div>

          {/* Update Button */}
          <button
            type="submit"
            disabled={loading}
            className={`w-full py-2 sm:py-3 rounded-md text-white font-semibold mt-4 transition text-sm sm:text-base ${
              loading
                ? "bg-gray-600 cursor-not-allowed"
                : "bg-gradient-to-r from-[#4e6d8c] to-[#6784a4] hover:opacity-90"
            }`}
          >
            {loading ? "Updating..." : "Update Info"}
          </button>

          {message && (
            <p className="text-center text-sm text-gray-300 mt-3 break-words px-2">
              {message}
            </p>
          )}
        </form>
      </div>
    </div>
  );
};

export default UpdateProfile;
